import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useMemo } from 'react';
import { pulseKeyframes, spinKeyframes } from '../../keyframes';
import { styled } from '../../system';
export const Icon = forwardRef(({ icon, shape = 'none', size = 'sm', duotoneOpacity = 0.4, ...props }, ref) => {
    const getOpacity = (i) => (i === 0 ? duotoneOpacity : 1);
    const viewBox = useMemo(() => '0 0 ' + icon.icon[0] + ' ' + icon.icon[1], [icon.icon]);
    const path = useMemo(() => icon.icon[4], [icon.icon]);
    return (_jsx(StyledSpan, { ref: ref, ...props, shape: shape, size: size, children: _jsx(StyledSvg, { "aria-hidden": true, viewBox: viewBox, xmlns: "http://www.w3.org/2000/svg", children: Array.isArray(path) ? (path.map((d, i) => (_jsx("path", { d: d, fill: "currentColor", fillOpacity: getOpacity(i) }, i)))) : (_jsx("path", { d: path, fill: "currentColor" })) }) }));
});
Icon.displayName = 'Icon';
const StyledSpan = styled('span', {
    d: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    lineHeight: 1,
    variants: {
        size: {
            xs: { minMaxSize: '$4', fontSize: '$xs' },
            sm: { minMaxSize: '$6', fontSize: '$sm' },
            md: { minMaxSize: '$8', fontSize: '$md' },
            lg: { minMaxSize: '$10', fontSize: '$lg' },
            xl: { minMaxSize: '$12', fontSize: '$xl' },
            '2xl': { minMaxSize: '$14', fontSize: '$2xl' },
            '3xl': { minMaxSize: '$16', fontSize: '$3xl' },
            '4xl': { minMaxSize: '$20', fontSize: '$4xl' },
            '5xl': { minMaxSize: '$24', fontSize: '$5xl' },
            '6xl': { minMaxSize: '$28', fontSize: '$6xl' },
            '7xl': { minMaxSize: '$32', fontSize: '$7xl' }
        },
        shape: {
            square: { rounded: 0 },
            rounded: { rounded: '$md' },
            circle: { rounded: '$full' },
            none: { minMaxSize: 'auto' }
        },
        spin: {
            true: {
                animation: `${spinKeyframes} 1s infinite linear`
            }
        },
        pulse: {
            true: {
                animation: `${pulseKeyframes} 1s infinite ease-in-out`
            }
        }
    },
    defaultVariants: {
        shape: 'none',
        size: 'sm'
    }
});
const StyledSvg = styled('svg', {
    size: '1em'
});
